import { MopResource } from './mopresource';

export class AzureResourceGroup extends MopResource {
    public azureId: string;

    public _links: {
        self: {
            href: string;
        };
    };

    constructor(object) {
        super(object);
    }

    public getName() {
        return this.name;
    }

    public getSaveObject() {
        return {};
    }
}
